const NORMAL = 0;
const MILD = 1;
const MORDERATE = 2;
const SERVERE = 3;
const EXTREMELY_SERVERE = 4;

export const ratingLabels = ["bình thường", "nhẹ", "vừa", "nặng", "rất nặng"];

export const ratingColors = [
  "#21bf73",
  "#3282b8",
  "#fdd365",
  "#ffa34d",
  "#f64b3c"
];

export const getLevel = (score, normal, mild, morderate, servere) => {
  let level = NORMAL;
  const doubleScore = score * 2;
  switch (true) {
    case doubleScore <= normal:
      level = NORMAL;
      break;
    case doubleScore <= mild:
      level = MILD;
      break;
    case doubleScore <= morderate:
      level = MORDERATE;
      break;
    case doubleScore <= servere:
      level = SERVERE;
      break;
    default:
      level = EXTREMELY_SERVERE;
      break;
  }
  return level;
};

export const stressLevel = score => getLevel(score, 14, 18, 25, 33);

export const anxietyLevel = score => getLevel(score, 7, 9, 14, 19);

export const depressLevel = score => getLevel(score, 9, 13, 20, 27);
